import Vue from 'vue'
import Router from 'vue-router'
import VueHead from 'vue-head'

import Home from './views/Home.vue'
import Admin from './views/Admin.vue'
import Brand from './views/Brand.vue'

import AdminHome from './views/admin/AdminHome.vue'
import AdminBrand from './views/admin/AdminBrand.vue'

Vue.use(VueHead)
Vue.use(Router)

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/brands/:brandSlug',
      name: 'brand',
      component: Brand,
      props: true
    },
    {
      path: '/admin',
      component: Admin,
      children: [
        {
          path: '',
          name: 'admin',
          component: AdminHome
        },
        {
          path: '/admin/brands/:brandSlug',
          name: 'admin-brand',
          component: AdminBrand,
          props: true
        }
      ]
    }
  ]
})
